import { gql } from 'apollo-boost';

const manyQuery = gql`
  query {
    clubs {
      id
      shortName
      fullName
      status
      createdAt
      updatedAt
    }
  }
`;

const oneQuery = gql`
  query club($id: Int!) {
    club(id: $id) {
      id
      shortName
      fullName
      status
      createdAt
      updatedAt
    }
  }
`;

export const createMutation = gql`
  mutation createClub($inputData: ClubInputType!) {
    createClub(inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updateClub($id: Int!, $inputData: ClubInputType!) {
    updateClub(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteClub($id: Int!) {
    deleteClub(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

const CLUBS = {
  manyQuery,
  oneQuery,
  createMutation,
  updateMutation,
  deleteMutation,
};

export default CLUBS;
